var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApexAiRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8465 45.585C38.9031 45.585 26.8071 50.7358 22.3771 53.3112C18.8135 55.0772 17.4254 52.5753 17.1767 51.1037C17.1767 38.7418 11.7836 27.1894 9.08697 22.9584C7.70017 20.3094 9.6648 18.5434 10.8205 17.9916C26.5375 17.1086 37.0155 12.105 40.2899 9.71357C44.4503 8.38909 45.8756 11.0013 46.0682 12.4729C46.5305 24.3933 52.0391 36.5712 54.7357 41.1701C56.1225 44.2605 53.3874 45.4011 51.8465 45.585Z",
    stroke: "white",
    strokeWidth: 3.10042
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5338 54.7897C26.2595 45.8367 14.7966 40.9176 10.0994 39.5771C6.54231 38.2942 7.46685 35.6595 8.37376 34.5024C17.3268 26.2281 22.2459 14.7651 23.5863 10.0679C24.6183 7.3356 27.1532 7.51249 28.2916 7.94248C38.9785 18.2229 49.3006 22.1215 53.1257 22.7857C56.7446 24.7769 55.7639 27.5113 54.8212 28.6295C46.4834 36.9281 41.1852 48.8896 39.5783 53.833C38.2266 56.8609 35.6521 55.7324 34.5338 54.7897Z",
    stroke: "white",
    strokeWidth: 3.10042
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApexAiRotate);
export default __webpack_public_path__ + "static/media/apex_ai_rotate.338e41dcf8c975cc1505172b1443fe71.svg";
export { ForwardRef as ReactComponent };